<script lang="ts">
    import { Color } from "@/types/UITypes";
    import Icon from "@components_v2/Icon.svelte";
    import SpinnerIcon from "@components_v2/Icons/SpinnerIcon.svelte";
    import Text from "@components_v2/Typography/Text.svelte";

    export let size = 20;
    export let color: Color | null = null;
    export let accessibilityLabel: string | null = null;
    export let hasFocusableParent: boolean | null = null;
</script>

<span
    class="gw-spinner"
    style:color={`var(${color})`}
    role={hasFocusableParent ? undefined : "status"}
>
    <Icon width={size} height={size}>
        <SpinnerIcon />
    </Icon>

    {#if accessibilityLabel}
        <Text component="span" visuallyHidden>{accessibilityLabel}</Text>
    {/if}
</span>

<style lang="postcss">
    .gw-spinner {
        display: flex;
        color: var(--gw-text-primary);

        :global(svg) {
            animation: rotate 500ms linear infinite;
        }
    }

    @keyframes rotate {
        100% {
            transform: rotate(1turn);
        }
    }
</style>
